import { PairsV4 } from '@ui/services/contract/hooks/PairsManagerFacet/usePairsV4';
import { MarketInfo } from '@ui/services/contract/hooks/TradingReaderFacet/useGetMarketInfos/query';
import BigNumber from 'bignumber.js';

export const getMaxInputMaxShortOIUsd = ({
  shortQty,
  maxShortOiUsdBuffered,
  pairPrice,
  leverage,
  spreadPercentage,
}: {
  maxShortOiUsdBuffered: PairsV4['maxShortOiUsdBuffered'];
  shortQty: MarketInfo['shortQty'];
  pairPrice: BigNumber;
  leverage: number;
  spreadPercentage: number;
}) => {
  /**
   * currentPositionQty * marketPrice + shortQty * marketPrice < maxShortOiUsdBuffered
   *
   * currentPositionQty * marketPrice < maxShortOiUsdBuffered - shortQty * marketPrice
   *
   * currently returning is maxShortOiUsdBuffered - shortQty * marketPrice
   *
   * turn it into pay token usd, need to divide leverage
   *
   */

  const maxShortUIUsdInPositionSize = maxShortOiUsdBuffered
    .multipliedBy(1 - spreadPercentage)
    .minus(shortQty.multipliedBy(pairPrice));

  return maxShortUIUsdInPositionSize.div(leverage);
};
